/**
 * @file
 * VUE Filters
 * Used in library: vue
 *
 * Use this file to register filters
 * See https://vuejs.org/v2/guide/filters.html
 * This configuration will be set in @/bootstrap/app.ts
 */
import { $ } from '../simpli';
/**
 * VUE Filters
 */
export var defaultFilters = {
    truncate: function (value, length) {
        if (!value)
            return '';
        if (value.length > (length || 0)) {
            return value.substring(0, length) + "...";
        }
        return value;
    },
    removeDelimiters: function (value) {
        if (!value)
            return '';
        return value.replace(/[. ,:\-/]+/g, '');
    },
    rg: function (value) {
        if (!value)
            return '';
        var v = value.replace(/\D/g, '');
        v = v.replace(/(\d{2})(\d{3})(\d{3})(\d{1})$/, '$1.$2.$3-$4');
        return v;
    },
    cpf: function (value) {
        if (!value)
            return '';
        var v = value.replace(/\D/g, '');
        v = v.replace(/(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
        return v;
    },
    cnpj: function (value) {
        if (!value)
            return '';
        var v = value.replace(/\D/g, '');
        v = v.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
        return v;
    },
    cpfOrCnpj: function (val) {
        if (val) {
            var str = val.replace(/\D/g, '');
            if (str.length === 11) {
                return str.replace(/(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
            }
            if (str.length === 14) {
                return str.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
            }
            return str;
        }
        return '';
    },
    phone: function (value) {
        if (!value)
            return '';
        var v = value.replace(/\D/g, '');
        v = v.replace(new RegExp($.t('filter.phone.regex')), $.t('filter.phone.format'));
        return v;
    },
    cep: function (value) {
        if (!value)
            return '';
        var v = value.replace(/\D/g, '');
        v = v.replace(new RegExp($.t('filter.cep.regex')), $.t('filter.cep.format'));
        return v;
    },
    pad: function (value, length) {
        if (length === void 0) { length = 2; }
        var str = "" + (value || '');
        while (str.length < length)
            str = "0" + str;
        return str;
    },
};
//# sourceMappingURL=filter.config.js.map